import React from "react";

// Collapsible-section chevron — matches the reference HTML's chevron-icon:
//   viewBox 0 0 24, stroke currentColor (inherits panel text color),
//   stroke-width 2, rounded line caps/joins, 15x15.
// Closed → down (V), Open → up (^).
export const SectionChevron = ({ open }) => (
    <svg
        className={'section-chevron'}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        {open
            ? <polyline points="7 15 12 9 17 15"/>
            : <polyline points="7 9 12 15 17 9"/>}
    </svg>
)
